import { Button } from 'antd';
import React, { useState } from 'react';
import { RecordType } from '@melio/payments-recon-api-client-ts';
import { api } from '@tools/ui/api';
import { openToast } from '@tools/ui-utils/toast.util';
import { usePermissions } from '../../../../hooks/usePermissions';

export const UnmatchRecord: React.FC<{
  recordId: string;
  recordType: RecordType;
  onComplete: () => void;
}> = ({ recordId, recordType, onComplete }) => {
  const [isRunning, setIsRunning] = useState(false);
  const { isAdmin } = usePermissions();

  if (!isAdmin) {
    return null;
  }

  return (
    <Button
      type="default"
      size="small"
      disabled={!isAdmin || isRunning}
      loading={isRunning}
      style={{ marginRight: 10 }}
      onClick={() => {
        setIsRunning(true);

        api
          .request({
            method: 'post',
            url: `/recon/${recordType}-records/${recordId}/removeMatch`
          })
          .then((response) => {
            openToast({
              type: 'success',
              placement: 'bottomLeft',
              message: 'Success',
              description: `Record successfully unmatched`
            });

            onComplete();
          })
          .catch(() => {
            openToast({
              type: 'error',
              placement: 'bottomLeft',
              message: 'Failure',
              description: 'There was an error unmatching the record'
            });
          })
          .finally(() => {
            setIsRunning(false);
          });
      }}
    >
      Unmatch
    </Button>
  );
};
